import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ModalModule} from 'ng2-bootstrap/modal';
// import { UserCalendarService} from '../services/lookups/user-calendar.service';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {CalendarModule} from 'primeng/calendar';
import {DropdownModule} from 'primeng/dropdown';
import {TabViewModule} from 'primeng/tabview';
import {TreeModule} from 'primeng/tree';

import {AutoSelectDirective} from '../components/directives/auto-select.directive';
import {QueryComponent} from '../components/ui/filter/query-component';
import {QueryCriterionComponent} from '../components/ui/filter/query-criterion-component';
import {AutoCompleteCmbComponent} from '../components/ui/auto-complete-cmb/auto-complete-cmb.component';
import {AutoCompleteCmbMultipleComponent} from 'app/components/ui/auto-complete-cmb-multiple/auto-complete-cmb-multiple.component';
import {ItemGroupTreeComponent} from '../components/ui/item-group-tree/item-group-tree.component';
// import { UserCalendarComponent } from '../components/ui/user-calendar/user-calendar.component';
// import { NewCalendarItemComponent } from '../components/ui/user-calendar/new-calendar-item/new-calendar-item.component';
import {ItemService} from '../services/lookups/item.service';
import {NabavkaService} from '../services/nabavke/nabavka.service';
import {SpecifikacijaService} from 'app/services/nabavke/specifikacija.service';
import {ContractService} from 'app/services/nabavke/contract.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CalendarModule,
    AutoCompleteModule,
    TreeModule,
    TabViewModule,
    ModalModule.forRoot(),
    DropdownModule
  ],
  declarations: [
    AutoSelectDirective,
    QueryComponent,
    QueryCriterionComponent,
    AutoCompleteCmbComponent,
    AutoCompleteCmbMultipleComponent,
    ItemGroupTreeComponent
//        UserCalendarComponent,
//        NewCalendarItemComponent
  ],
  exports: [
    AutoSelectDirective,
    QueryComponent,
    QueryCriterionComponent,
    AutoCompleteCmbComponent,
    ItemGroupTreeComponent,
    AutoCompleteCmbMultipleComponent
//        UserCalendarComponent,
//        NewCalendarItemComponent
  ],
  entryComponents: [
    QueryCriterionComponent
  ],
  providers: [
    ItemService,
    NabavkaService,
    SpecifikacijaService,
    ContractService
//      UserCalendarService
  ]

})
export class UIHelpersModule {
}
